module.exports = {"requirements":"You must have cookies and Javascript enabled in your browser.","legalPrefix":"©","legalSuffix":"showtix4u All rights reserved.","links":[{"text":"Contact us","url":"","external":false,"calendly":true},{"text":"ShowTix4U Status","url":"http://status.showtix4u.com","external":true,"calendly":false},{"text":"Privacy policy","url":"/privacy-policy","external":false,"calendly":false},{"text":"Terms of service","url":"/terms","external":false,"calendly":false},{"text":"Accessibility","url":"/accessibility","external":false,"calendly":false}]}


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/locales/en.json
// module id = 795
// module chunks = 0